import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 26/28;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 28 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.109 10.027v4.819H28v-4.819H7.109zm19.585 3.42H8.414v-2.02h18.28v2.02zM7.11 20.442H28v-4.818H7.109v4.818zm1.306-3.42h18.28v2.021H8.414v-2.02zM7.109 26H28v-4.819H7.109V26zm1.306-3.42h18.28v2.021H8.414v-2.02zM20.89 8.396h5.658V0H0v8.395H20.891zm0-6.996h4.352v5.596h-4.352V1.4zM1.306 6.995V1.4h18.28v5.596H1.305zm20.418-3.474h2.86l-1.43 1.948-1.43-1.948z" fill={color} fillRule="nonzero"/>
    </svg>
)

export default class IconFieldDropdown extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
